export enum InfoCollapseTypeEnum {
  DEFAULT = 'default',
  INFO = 'info',
  POSITIVE = 'positive',
  NEGATIVE = 'negative',
  WARNING = 'warning'
}
